import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import { styled } from '@mui/material/styles'
import Typography from '@components/_mui/Typography'

export const IconCircleButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  borderRadius: '50%',
  transition: theme.transitions.create(['background-color'], {
    duration: theme.transitions.duration.short,
  }),
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
  '&.MuiIconButton-sizeSmall': {
    width: '24px',
    height: '24px',
    fontSize: '18px',
  },
  '&.MuiIconButton-sizeMedium': {
    width: '32px',
    height: '32px',
    fontSize: '22px',
  },
  '&.MuiIconButton-sizeLarge': {
    width: '40px',
    height: '40px',
    fontSize: '26px',
  },
}))

export function Empty({ label = 'No data to display' }) {
  return (
    <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Typography variant="h6" align="center" sx={{ color: 'text.secondary', p: 2 }}>
        {label}
      </Typography>
    </Box>
  )
}
